import React from 'react';
import { useState} from 'react';

import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import Layout from './Layout.js';
import Header from './Header'; 
import SignInPage from './SignInPage';
import SignUpPage from './SignUpPage';
// import CareerPage from './CareerPage';
import CareersPage from './CareersPage.jsx';

import HomeBanner from './HomeBanner';
import ContactUs from './ContactUs';
import Services from './Services';
import OurBrand from './OurBrand';
import AboutUs from './AboutUs';
// import PropertyDetails from './components/PropertyDetails';
import CustomPropertyPage from './components/CustomPropertyPage.jsx';
import NriGuide from './Pages/NriGuide/NriGuide';
import LeasingPage from './Pages/Lease_with_us/LeasingPage';
import FacilityManagementPage from './Pages/Facility-management/Facility';
import PaintingServicesPage from './Pages/painting-services/Painting';
import RealEstateInvestment from './Pages/Invest-real/Investreal';
import ViewMoreProperty from './components/ViewMoreProperty';
import SellHome from './Pages/Sell_your_home/HomeSellingServices';
import Vastu from './Pages/vastu_consultation/vastuConsultation';
import ConstructionServices from './Pages/Construction/ConstructionServices';
import HomeInteriorPage from './Pages/Home-interiror/Homeinter.js';
import LegalDocuments from './PropertyDetailsComponents/LegalDocuments';
import DeveloperProperties from './Developers/DeveloperProperties';

function App() {
  const [isLoggedIn, setIsLoggedIn] = useState(!!localStorage.getItem('token'));

  return (
    <Router>
      <Layout>
        <Header />
      <Routes>
        <Route path="/" element={<HomeBanner />} />
        <Route path="/sign-in" element={<SignInPage setIsLoggedIn={setIsLoggedIn}/>} />
        <Route path="/sign-up" element={<SignUpPage />} />
        <Route path="/career" element={<CareersPage/>} />
        <Route path="/contactus" element={<ContactUs/>} />
        <Route path="/service" element={<Services/>} />
        <Route path="/property-cards" element={<ViewMoreProperty/>} />
        <Route path="/brand" element={<OurBrand/>} />
        <Route path="/about-us" element={<AboutUs/>} />
         {/* <Route path="/property/:slug" element={<PropertyDetails />} /> */}
         <Route path="/property/:slug" element={<CustomPropertyPage isLoggedIn={isLoggedIn} />} />
         <Route path="/NRI-guide" element={<NriGuide/>}/>
         <Route path="/Lease-with-us" element={<LeasingPage/>}/>
          <Route path="Facility-Management" element={<FacilityManagementPage/>}/>
          <Route path="painting-services" element={<PaintingServicesPage/>}/>
          <Route path="Invest-real" element={<RealEstateInvestment/>}/>
             <Route path="/buy" element={<ViewMoreProperty/>} />
          <Route path="/Home-interiror" element={<HomeInteriorPage/>} />
          <Route path="/developers/:searchTerm" element={<DeveloperProperties />} />

         <Route path="/sell-your-home" element={<SellHome/>}/>
         <Route path="/construction" element={<ConstructionServices/>}/>
         <Route path="/vastu-consultation" element={<Vastu/>}/>
          <Route path="/properties/:propertyId/legal-documents" element={<LegalDocuments />} />     

         

      </Routes>
      </Layout>
    </Router>
  );
}

export default App;
